import type {
  GetPrinterGroupsResponse,
  GetPrintersResponse,
  GetStatusResponse,
} from '@myparcel-frontend/printing-service';
import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useDirectPrintingStore = defineStore('directPrinting', () => {
  const printerGroups = ref<GetPrinterGroupsResponse['results']>([]);
  const printers = ref<GetPrintersResponse['results']>([]);
  const status = ref<GetStatusResponse['status']>();
  const pendingPrintJobs = ref<string[]>([]);

  const removePrinterGroup = (group: GetPrinterGroupsResponse['results'][number]) => {
    printerGroups.value = printerGroups.value.filter((printerGroup) => printerGroup.id !== group.id);
  };

  const updatePrinterGroup = (id: string, group: Omit<Partial<GetPrinterGroupsResponse['results'][number]>, 'id'>) => {
    const index = printerGroups.value.findIndex((group) => group.id === id);

    if (index === -1) {
      return;
    }

    const printerGroup = printerGroups.value[index];

    printerGroups.value[index] = {
      ...printerGroup,
      ...group,
    };
  };

  const hasPendingPrintJobs = (printerGroupId: string) => {
    return pendingPrintJobs.value.includes(printerGroupId);
  };

  const removePendingPrintJob = (printerGroupId: string) => {
    pendingPrintJobs.value = pendingPrintJobs.value.filter((id) => id !== printerGroupId);
  };

  return {
    printerGroups,
    printers,
    status,
    pendingPrintJobs,
    removePrinterGroup,
    updatePrinterGroup,
    hasPendingPrintJobs,
    removePendingPrintJob,
  };
});
